
import './App.css';
import './Components/Admin/AdminGlobal.css';
import './Components/Admin/NavbarDashboard/NavbarDashboard.css';
import './Components/Admin/HeaderDash/HeaderDash.css';
import './Components/Admin/TiendaData/TiendaData.css';
import './Components/Admin/MetodosData/MetodosData.css';
import './Components/Admin/PedidosData/PedidosData.css';
import './Components/Admin/PedidosData/PedidosDataViev.css';
import './Components/Admin/BannerData/BannerData.css';
import './Components/Admin/CodigosData/CodigosData.css';
import './Components/Admin/NewCodigo/NewCodigo.css';
import './Components/Admin/UsuariosData/UsuariosData.css';
import './Components/Admin/CategoriasData/CategoriasData.css';
import './Components/Admin/NewCategoria/NewCategoria.css';
import './Components/Admin/NewPedido/NewPedido.css';
import './Components/Admin/Estado/Estado.css';
import './Components/Admin/CardsCantidad/CardsCantidad.css';
import './Components/Admin/AdminBase.css';
import './Components/Admin/MetricsCards/MetricsCards.css';
import './Components/Admin/FirewallToggle/FirewallToggle.css';
import './Components/Admin/AttackStats/AttackStats.css';
import './Components/Admin/FooterPagesData/FooterPagesData.css';
import './Components/Admin/FooterLinksData/FooterLinksData.css';
import './Components/Admin/FlyerData/FlyerData.css';
import './Components/Admin/BlocksData/BlocksData.css';
import './Components/Admin/ProductosMain/ProductosMain.css';
import './Components/Admin/ReviewsData/ReviewsData.css';
import './Components/Admin/Register/Register.css';
import './Components/Admin/NewBanner/NewBanner.css';
import './Components/Admin/NewProduct/NewProduct.css';
import './Components/Admin/MoreProductsData/MoreProductsData.css';
import './Components/Admin/Spiner/Spiner.css';
import './Components/Admin/QrGenerator/QrGenerator.css';
import './Components/Admin/UsuariosMain/UsuariosMain.css';
import './Components/Admin/InfoUserMain/InfoUserMain.css';
import './Components/Admin/InfoUser/InfoUser.css';
import './Components/Admin/Auth/Auth.css';
import './Components/Admin/InputSearch/InputSearch.css';
import './Pages/Main/Main.css';
import { router, } from "./Pages/index";
import { RouterProvider } from "react-router-dom";
import React from 'react'


function App() {


  return (

    <RouterProvider router={router} />

  );
}

export default App;
